module.exports = __webpack_public_path__ + "img/poster-last-wechat.98545b43.png";